<template>
    <div class="form-error">
        {{ error }}
    </div>
</template>
<script>
export default {
    props: {
        error: {
            required: true,
            type: String,
        },
    },
};
</script>
